export default "__VITE_ASSET__CBz1krlY__"